import * as React from 'react';
import PropTypes from 'prop-types';

const IconChevronDown = ({
    width = '40',
    height = '40',
    className = '',
    ...other
}) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 40 40"
        fill="none"
        className={className}
        {...other}
    >
        <path d="M20 25.625L10 15.625L12.3333 13.2916L20 20.9583L27.6667 13.2916L30 15.625L20 25.625Z" fill="currentColor" />
    </svg>
);

export default IconChevronDown;

IconChevronDown.propTypes = {
    height: PropTypes.string,
    width: PropTypes.string,
    className: PropTypes.string,
};
